import { Button, Spinner } from "react-bootstrap";
import YearSelect from "./YearSelect";


interface SearchExportProps {
    selectedYear: number;
    setSelectedYear: (value: number) => void;
    onStart?: () => void | Promise<void>;
    availableYears?: number[];
    loading?: boolean;
    disabledStart?: boolean;
    startButtonLabel?: string;
    showStartButton?: boolean;

    startButtonTitle?: string;
}

const SearchExport = ({
    selectedYear,
    setSelectedYear,
    onStart,
    availableYears = [2026, 2025],
    loading = false,
    disabledStart = false,
    startButtonLabel = "INICIAR MERITOCRACIA",
    showStartButton = true,
    startButtonTitle,
}: SearchExportProps) => {
    return (
        <div className="shipping-top-actions">
            <YearSelect
                value={selectedYear}
                onChange={setSelectedYear}
                options={availableYears}
                disabled={loading}
                aria-label="Selecionar ano de referência"
            />

            {showStartButton ? (
                <Button
                    className="shipping-start-btn"
                    onClick={onStart}
                    disabled={loading || disabledStart}
                    title={startButtonTitle}
                >
                    {loading ? (
                        <Spinner animation="border" size="sm" variant="light" />
                    ) : (
                        startButtonLabel
                    )}
                </Button>
            ) : null}
        </div>
    );
};

export default SearchExport;